import { useEffect, useRef, useState } from "react";
import { Play } from "lucide-react";
import { API } from "../lib/api";

export const VideoThumb = ({ videoId, className = "", testid }) => {
  const videoRef = useRef(null);
  const [poster, setPoster] = useState(null);

  const capture = () => {
    const vid = videoRef.current;
    if (!vid || vid.videoWidth === 0) return;
    try {
      const canvas = document.createElement("canvas");
      canvas.width = vid.videoWidth;
      canvas.height = vid.videoHeight;
      canvas.getContext("2d").drawImage(vid, 0, 0, canvas.width, canvas.height);
      setPoster(canvas.toDataURL("image/jpeg", 0.7));
    } catch (err) {
      console.warn("Thumbnail capture skipped (cross-origin/tainted):", err);
    }
  };

  const onMeta = () => {
    const vid = videoRef.current;
    if (!vid) return;
    const t = Number.isFinite(vid.duration) ? Math.min(0.8, vid.duration * 0.25) : 0.6;
    try { vid.currentTime = t; } catch (err) { console.warn("Thumbnail seek not ready:", err); }
  };

  useEffect(() => () => { if (videoRef.current) videoRef.current.src = ""; }, []);

  return (
    <div className={`relative ${className}`} data-testid={testid}>
      {poster ? (
        <img src={poster} alt="Swing thumbnail" data-testid={`${testid}-img`}
             className="w-full h-full object-cover opacity-85 group-hover:opacity-100 transition" />
      ) : (
        <video
          ref={videoRef}
          src={`${API}/videos/${videoId}/file#t=0.6`}
          className="w-full h-full object-cover opacity-85 group-hover:opacity-100 transition"
          muted playsInline preload="metadata"
          onLoadedMetadata={onMeta}
          onSeeked={capture}
        />
      )}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <span className="w-12 h-12 rounded-full bg-black/45 backdrop-blur-sm flex items-center justify-center opacity-80 group-hover:opacity-100 group-hover:scale-110 transition">
          <Play size={18} className="text-white translate-x-[1px]" fill="white" />
        </span>
      </div>
    </div>
  );
};
